import {
  DEFAULT_PORTAL_LANGUAGE,
  PORTAL_LANGUAGES,
  getPortalLanguageConfig,
  isPortalLanguage,
} from "../configs/portalLanguages";

export { PORTAL_LANGUAGES };

const PORTAL_LANGUAGE_KEY = "portal_language";

export const resolvePortalLanguage = (config = {}) => {
  if (isPortalLanguage(config?.portal_language)) {
    return config.portal_language;
  }

  // Older profiles only contain a direction.
  return config?.direction === "rtl" ? "ar" : DEFAULT_PORTAL_LANGUAGE;
};

export const portalDirection = (language) =>
  getPortalLanguageConfig(language).direction;

export const portalCatalogLanguage = (language) =>
  getPortalLanguageConfig(language).catalogLanguage;

export const portalProductName = (product, config = {}) =>
  portalCatalogLanguage(resolvePortalLanguage(config)) === "ar"
    ? product?.name_ar || product?.name || product?.name_en || ""
    : product?.name_en || product?.name || product?.name_ar || "";

export const portalLanguageLabel = (language) =>
  getPortalLanguageConfig(language).label;

export const buildPortalAppConfig = (currentConfig = {}, language) => {
  const portal_language = isPortalLanguage(language)
    ? language
    : resolvePortalLanguage(currentConfig);

  return {
    ...currentConfig,
    portal_language,
    direction: portalDirection(portal_language),
  };
};

export const readStoredPortalLanguage = () => {
  if (typeof window === "undefined") return null;

  try {
    const language = window.localStorage.getItem(PORTAL_LANGUAGE_KEY);
    return isPortalLanguage(language) ? language : null;
  } catch {
    return null;
  }
};

export const storePortalLanguage = (language) => {
  if (typeof window === "undefined" || !isPortalLanguage(language)) return;

  try {
    window.localStorage.setItem(PORTAL_LANGUAGE_KEY, language);
  } catch {
    // The in-memory language still works when storage is unavailable.
  }
};
